// ============================================================
// Libellés et couleurs de l'état d'un serveur Ptero, partagés par les badges du panel
// (contrôles serveur, console, résultat de Release).
//
// `error` vient du CICD (champ `status` de /state) : Ptero dit running, mais le serveur
// d'API ne répond pas sur son ip:port ou redémarre en boucle. `unreadable` : l'état n'a
// pas pu être lu (CICD ou Ptero injoignable), ce n'est pas un diagnostic du serveur.
// ============================================================

export type PowerDisplay = 'running' | 'starting' | 'stopping' | 'offline' | 'error' | 'unreadable' | 'unknown';

export type PowerTone = 'success' | 'danger' | 'info' | 'warning' | 'muted';

export const POWER_META: Record<PowerDisplay, { label: string; tone: PowerTone }> = {
  running:    { label: 'En marche',      tone: 'success' },
  starting:   { label: 'Démarrage…',     tone: 'info' },
  stopping:   { label: 'Arrêt…',         tone: 'warning' },
  offline:    { label: 'Arrêté',         tone: 'muted' },
  error:      { label: 'Erreur',         tone: 'danger' },
  unreadable: { label: 'État illisible', tone: 'warning' },
  unknown:    { label: '…',              tone: 'muted' },
};

/** État Ptero brut, ou `status` du CICD ("error" compris), vers l'état affiché. */
export function powerDisplay(raw: string | undefined | null): PowerDisplay {
  switch (raw?.toLowerCase()) {
    case 'running': return 'running';
    case 'starting': return 'starting';
    case 'stopping': return 'stopping';
    case 'offline': return 'offline';
    case 'error': return 'error';
    default: return 'unknown';
  }
}
